/**
 * OTPSignup Page - Now uses UnifiedOTP component
 * Handles OTP-based signup for new patients
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import UnifiedOTP from '../components/UnifiedOTP';

const OTPSignup = () => {
  const navigate = useNavigate();

  const handleSuccess = (result) => {
    // Redirect to patient onboarding
    navigate('/onboarding/patient/');
  };

  const handleError = (error) => {
    console.error('OTP signup error:', error);
    // Error handling is done in UnifiedOTP component
  };

  return (
    <UnifiedOTP
      mode="signup"
      onSuccess={handleSuccess}
      onError={handleError}
      showSteps={true}
      title="Join MindWell 🚀"
      subtitle="Create your account with just your name and phone/email"
    />
  );
};

export default OTPSignup;